// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3jcWo","empty":"ModalGraph_empty__1eQTT"};